import { getQueryParamsString } from '../../utils/utils';
import { gqSvcPaymentPageApiClient } from './axios';
import { routes } from './routes';

// Auth
// export const authPlatformAuthorizeV01Post = (body) => {
//     return gqSvcPaymentPageApiClient({
//         method: routes.AUTHENTICATION_PLATFORM_AUTHORIZE_V01.METHOD,
//         url: routes.AUTHENTICATION_PLATFORM_AUTHORIZE_V01.URL,
//         data: body,
//     });
// };

// // Payment Pages
// export const paymentPagesFetchGet = (searchObj = null) => {
//     let queryString='';
//     if (searchObj) {
//         queryString = getQueryParamsString(searchObj);
//     }
//     return gqSvcPaymentPageApiClient({
//         method: routes.PAYMENT_PAGES_FETCH.METHOD,
//         url: `${routes.PAYMENT_PAGES_FETCH.URL}${queryString ? `?${queryString}` : ''}`,
//     });
// };

// export const paymentPagesFeeTypesFetchGet = (searchObj = null) => {
//     let queryString='';
//     if (searchObj) {
//         queryString = getQueryParamsString(searchObj);
//     }
//     return gqSvcPaymentPageApiClient({
//         method: routes.PAYMENT_PAGES_FEE_TYPES_FETCH.METHOD,
//         url: `${routes.PAYMENT_PAGES_FEE_TYPES_FETCH.URL}${queryString ? `?${queryString}` : ''}`,
//     });
// };

// export const paymentPagesFeeTypesCalculatePost = (body = null) => {
//     return gqSvcPaymentPageApiClient({
//         method: routes.PAYMENT_PAGES_FEE_TYPES_CALCULATE.METHOD,
//         url: `${routes.PAYMENT_PAGES_FEE_TYPES_CALCULATE.URL}${body?.payment_page_slug ? `?payment_page_slug=${body?.payment_page_slug}` : ''}`,
//         data: body,
//     });
// };

// // Form Editor / Form Fields
// export const formEditorFormFieldsUpdatePatch = (body) => {
//     return gqSvcPaymentPageApiClient({
//         method: routes.FORM_EDITOR_FORM_FIELDS_UPDATE.METHOD,
//         url: routes.FORM_EDITOR_FORM_FIELDS_UPDATE.URL,
//         data: body,
//     });
// };

// // Student
// export const studentsGet = (searchObj = null) => {
//     const queryString = getQueryParamsString(searchObj);
//     return gqSvcPaymentPageApiClient({
//         method: routes.STUDENTS_FETCH.METHOD,
//         url: `${routes.STUDENTS_FETCH.URL}${queryString ? `?${queryString}` : ''}`,
//     });
// };

// export const studentsCreatePost = (body) => {
//     return gqSvcPaymentPageApiClient({
//         method: routes.STUDENTS_CREATE.METHOD,
//         url: routes.STUDENTS_CREATE.URL,
//         data: body,
//     });
// };

// export const studentsWrapperCreatePost = (body) => {
//     return gqSvcPaymentPageApiClient({
//         method: routes.STUDENTS_WRAPPER_CREATE.METHOD,
//         url: routes.STUDENTS_WRAPPER_CREATE.URL,
//         data: body,
//     });
// };

// export const studentsReceiptFetch = (searchObj = null) => {
//     const queryString = getQueryParamsString(searchObj);
//     return gqSvcPaymentPageApiClient({
//         method: routes.STUDENTS_RECEIPT_FETCH.METHOD,
//         url: `${routes.STUDENTS_RECEIPT_FETCH.URL}${queryString ? `?${queryString}` : ''}`,
//     });
// };

// // GILE Class
// export const gileClassesFetchGet = (searchObj = null) => {
//     let queryString='';
//     let group_code='';
//     if (searchObj) {
//         group_code = searchObj?.group_code;
//         delete searchObj.group_code;
//         queryString = getQueryParamsString({ ...searchObj, dropdown: 'true'});
//     }
//     return gqSvcPaymentPageApiClient({
//         method: routes.GILE_CLASSES_FETCH.METHOD,
//         url: `${routes.GILE_CLASSES_FETCH.URL}/${group_code}/classes/fetch${queryString ? `?${queryString}` : ''}`,
//     });
// };

// // Update customer mobile
// export const customerDetailsUpdateMobilePatch = (body) => {
//     return gqSvcPaymentPageApiClient({
//         method: routes.CUSTOMER_DETAILS_UPDATE_MOBILE_PATCH.METHOD,
//         url: routes.CUSTOMER_DETAILS_UPDATE_MOBILE_PATCH.URL,
//         data: body,
//     });
// };

// MISC
// Session code
export const miscSessionFetch = (searchObj = null) => {
    let queryString = '';
    if (searchObj) {
        queryString = getQueryParamsString(searchObj);
    }
    return gqSvcPaymentPageApiClient({
        method: routes.SESSION_FETCH.METHOD,
        url: `${routes.SESSION_FETCH.URL}${queryString ? `?${queryString}` : ''}`,
    });
};

export const miscSessionCreatePost = (body = null) => {
    return gqSvcPaymentPageApiClient({
        method: routes.SESSION_CREATE_POST.METHOD,
        url: routes.SESSION_CREATE_POST.URL,
        data: body,
    });
};

// Workflow
export const workflowFetchDetailsPost = (body = null) => {
    return gqSvcPaymentPageApiClient({
        method: routes.WORKFLOW_FETCH_DETAILS.METHOD,
        url: routes.WORKFLOW_FETCH_DETAILS.URL,
        data: body,
    });
};

// Email Verification

export const checkEmailPost = (body = null) => {
    return gqSvcPaymentPageApiClient({
        method: routes.CHECK_EMAIL_POST.METHOD,
        url: routes.CHECK_EMAIL_POST.URL,
        data: body,
    });
};

export const verifyEmailOtpPost = (body = null) => {
    return gqSvcPaymentPageApiClient({
        method: routes.VERIFY_EMAIL_OTP_POST.METHOD,
        url: routes.VERIFY_EMAIL_OTP_POST.URL,
        data: body,
    });
};

export const resendEmailOtpPost = (body = null) => {
    return gqSvcPaymentPageApiClient({
        method: routes.RESEND_EMAIL_OTP_POST.METHOD,
        url: routes.RESEND_EMAIL_OTP_POST.URL,
        data: body,
    });
};

/**
 * Creates a payment redirection link via PG Flow Wrapper API
 * @param {Object} body - Payment initiation data
 * @param {AbortSignal} signal - Optional abort signal
 * @returns {Promise<Object>}
 */
export const pgFlowWrapperPost = (body, signal) => {
    return gqSvcPaymentPageApiClient({
        method: routes.WRAPPER_PG_FLOW_POST.METHOD,
        url: routes.WRAPPER_PG_FLOW_POST.URL,
        data: body,
        signal,
    });
};

/**
 * Fetches order status via Order Status API
 * @param {string} order_code - Unique order identifier
 * @param {AbortSignal} signal - Optional abort signal
 * @returns {Promise<Object>}
 */
export const getOrderStatus = (order_code, signal) => {
    return gqSvcPaymentPageApiClient({
        method: routes.WRAPPER_ORDER_STATUS_GET.METHOD,
        url: routes.WRAPPER_ORDER_STATUS_GET.URL,
        params: { order_code },
        signal,
    });
};
